import React from 'react'

function Plane(props) {
    const { args = [200, 200], color = 0xcfcfff } = props;

    return (
        <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
            <planeGeometry args={args} />
            <meshPhongMaterial color={color} />
        </mesh>
    )
}

export default Plane;